module.exports = __webpack_public_path__ + "static/img/8.7001e3f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/2/eng/8.png
// module id = +2XP
// module chunks = 0